import React, { useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import Loading from "../Loading/Loading";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import { availableLanguages } from "../../Utils/availableLanguage";

export function LanguageRedirection() {
  const navigate = useNavigate();

  const changeWebsiteLang = useContext(LanguageContext).changeWebsiteLanguage;
  window.scrollTo(0, 0);
  const location = useLocation();
  const path = location.pathname;
  const pathSegments = path.split("/").slice(2);
  const lang = pathSegments.pop(); // Last segment is the lang
  const redirectedTo = path.split("/").slice(2, -2).join("/");

  useEffect(() => {
    if (!lang) {
      return navigate(`/${redirectedTo}`, { replace: true });
    }
    const isValidLang = availableLanguages.includes(lang);
    if (isValidLang) {
      changeWebsiteLang(lang);
    }

    navigate(`/${redirectedTo}`, { replace: true });
  }, []);

  return (
    <div style={{ height: "500px" }}>
      <Loading text={"Loading"}></Loading>
    </div>
  );
}
